// Third Party
import React from 'react';

// Components
import WarningModal from './WarningModal';

// Utils
import { formatMessage, FormattedMessage, formatLocalizedString } from '../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  items: ComparisonItem[];
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ESGNoDataModal = ({ items, show, onConfirm, onCancel }: Props) => {
  const getModalBody = () => (
    <>
      <FormattedMessage tagName="p" id="ESGComparisonTool.NoDataModal.Body" />
      <ul className="items-list">
        {items.map(item => (
          <li key={item._id}>{formatLocalizedString(item.name)}</li>
        ))}
      </ul>
    </>
  );

  return (
    <WarningModal
      title={formatMessage('ESGComparisonTool.NoDataModal.Title')}
      body={getModalBody()}
      confirmLabel={formatMessage('ESGComparisonTool.NoDataModal.Action')}
      className="esg-no-data-modal"
      show={show}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default ESGNoDataModal;
